import React from 'react'

 const Navbar=()=>{
    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">TempLive</a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link" href="/general">Forecast</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/general">Cities</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/general">Download app</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    )
  }


export default Navbar